import 'primeflex/primeflex.css'
import 'primeicons/primeicons.css'
import './assets/styles/primevue4-bridge.css'
import './assets/styles/layout.scss'

import { createApp, reactive } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import PrimeVue from 'primevue/config'
import Aura from '@primevue/themes/aura'
import { definePreset } from '@primevue/themes'
import Ripple from 'primevue/ripple'
import StyleClass from 'primevue/styleclass'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import Toast from 'primevue/toast'
import ToastService from 'primevue/toastservice'
import Checkbox from 'primevue/checkbox'
import Toolbar from 'primevue/toolbar'
import Dialog from 'primevue/dialog'
import Textarea from 'primevue/textarea'
import Dropdown from 'primevue/dropdown'
import FileUpload from 'primevue/fileupload'
import InputNumber from 'primevue/inputnumber'
import IconField from 'primevue/iconfield'
import InputIcon from 'primevue/inputicon'
import FloatLabel from 'primevue/floatlabel'
import Avatar from 'primevue/avatar'
import Menu from 'primevue/menu'
import { migrateAuthStorage } from './auth/storage'
import { setUnauthorizedHandler } from './service'

const VocabPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{indigo.50}',
      100: '{indigo.100}',
      200: '{indigo.200}',
      300: '{indigo.300}',
      400: '{indigo.400}',
      500: '{indigo.500}',
      600: '{indigo.600}',
      700: '{indigo.700}',
      800: '{indigo.800}',
      900: '{indigo.900}',
      950: '{indigo.950}'
    }
  }
})

const prefersDark = window.matchMedia('(prefers-color-scheme: dark)')
const applyDarkMode = () => {
  const pref = localStorage.getItem('vocab_dark')
  document.documentElement.classList.toggle('app-dark', pref === null ? prefersDark.matches : pref === '1')
}
applyDarkMode()
prefersDark.addEventListener('change', applyDarkMode)

async function bootstrap () {
  migrateAuthStorage()
  setUnauthorizedHandler(async () => {
    await store.dispatch('auth/logout')
    if (router.currentRoute.value.name !== 'Login' && router.currentRoute.value.name !== 'ExtensionAuth') {
      await router.push({ name: 'Login' })
    }
  })
  await store.dispatch('auth/initialize')

  router.beforeEach(() => {
    window.scrollTo(0, 0)
  })

  const app = createApp(App)
  app.config.globalProperties.$appState = reactive({ theme: 'tailwind-light', darkTheme: false })
  app.use(store)
  app.use(router)
  app.use(ToastService)
  app.use(PrimeVue, {
    ripple: true,
    theme: { preset: VocabPreset, options: { darkModeSelector: '.app-dark' } }
  })

  const components = {
    DataTable,
    Column,
    InputText,
    Button,
    Toast,
    Checkbox,
    Toolbar,
    Dialog,
    Textarea,
    Dropdown,
    FileUpload,
    InputNumber,
    IconField,
    InputIcon,
    FloatLabel,
    Avatar,
    Menu
  }
  Object.entries(components).forEach(([name, component]) => app.component(name, component))
  app.directive('ripple', Ripple)
  app.directive('styleclass', StyleClass)
  app.mount('#app')
}

bootstrap()
